import 'dom-slider';

VIV.behaviours.links = (function () {

    const attach = function (context) {
        context.querySelectorAll('.links').forEach(links => {
            init(links);
        });
    };

    const init = function (block) {
        const {slideDown, slideUp, slideToggle} = window.domSlider
        const showMoreLink = block.querySelector('.links__showMore');
        const hiddenItems = block.querySelector('.links__hiddenItems');
        const blockTextAndLinks = block.closest('.blockTextAndLinks')
        const textsWrapper = blockTextAndLinks && blockTextAndLinks.querySelector('.blockTextAndLinks__texts');

        if (showMoreLink && hiddenItems) {
            showMoreLink.addEventListener('click', function () {
                if (textsWrapper) {
                    const textsWrapper = blockTextAndLinks.querySelector('.blockTextAndLinks__texts');
                    textsWrapper.style.height = textsWrapper.offsetHeight + 'px';
                }
                slideDown({element: hiddenItems, slideSpeed: 200});
                showMoreLink.remove();
            });
        }

        if (textsWrapper) {
            const resizeHandler = function () {
                textsWrapper.style.height = 'auto';
                window.removeEventListener('resize', resizeHandler);
            };
            window.addEventListener('resize', resizeHandler);
        }
    };

    return {
        attach: attach
    }
})();
